import React, { use, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { format } from "date-fns";
import {
  fetchMeetings,
  deleteMeetingById,
} from "../../store/features/meeting/meetingSlice";
import { Button, Table, Spinner, Badge } from "react-bootstrap";
import { toast } from "react-toastify";
import { BsPencilSquare, BsTrash } from "react-icons/bs";

import MeetingModal from "./components/modals/MeetingModal";
import PageTitle from "../../components/pageTitle";
import NoDataFound from "../../components/NoDataFound";

import { SiGooglemeet } from "react-icons/si";
import ReactPaginate from "react-paginate";

function Meeting() {
  const dispatch = useDispatch();
  const {
    meetings = [],
    loading,
    pagination,
  } = useSelector((state) => state.meetings);
  const { workPackages } = useSelector((state) => state.workPackages);
  const { tasks } = useSelector((state) => state.tasks);
  const { role } = useSelector((state) => state.auth);
  const [editingMeeting, setEditingMeeting] = useState(null);
  const [showForm, setShowForm] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const limit = 10;
  const [expandedDescriptions, setExpandedDescriptions] = useState({});

  useEffect(() => {
    dispatch(fetchMeetings({ page: currentPage + 1, limit }));
  }, [dispatch, currentPage]);

  const handleEdit = (meeting) => {
    setEditingMeeting(meeting);
    setShowForm(true);
  };

  const handledelete = async (id) => {
    try {
      await dispatch(deleteMeetingById(id)).unwrap();
      await dispatch(fetchMeetings());
      toast.info("Meeting deleted");
    } catch {
      toast.error("Error deleted Meeting");
    }
  };

  const handlePageClick = (event) => {
    setCurrentPage(event.selected);
  };
  const toggleDescription = (id) => {
    setExpandedDescriptions((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  return (
    <>
      <PageTitle
        setShowForm={setShowForm}
        setEditing={setEditingMeeting}
        pageTitle={"Meeting"}
        pageSubtitle={
          "Manage users, roles, and permissions across the platfrom"
        }
        actionName={role === "staff" ? "" : "Create meeting"}
      />

      {loading ? (
        <Spinner animation="border" />
      ) : (
        <>
          {meetings?.length > 0 ? (
            <div className="table-wrapper">
              <Table responsive>
                <thead>
                  <tr>
                    <th>Title</th>
                    <th>Organizer</th>
                    <th>Attendees</th>
                    <th>Project</th>
                    <th>WP</th>
                    <th>Tasks</th>
                    <th>Link</th>
                    <th>Objective</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>Time</th>
                    <th>Duration</th>
                    <th>Platform</th>
                    <th>Type</th>
                    {role !== "staff" && <th>Actions</th>}
                  </tr>
                </thead>
                <tbody>
                  <>
                    {meetings?.map((meet) => (
                      <tr key={meet._id}>
                        <td>{meet.title}</td>
                        <td>{meet?.organizerDetails?.name}</td>
                        <td>
                          {meet.attendees?.map((user) => {
                            return (
                              <Badge bg="secondary" className="me-1">
                                {user.name}
                              </Badge>
                            );
                          })}
                        </td>
                        <td>{meet?.project?.projectName}</td>
                        <td>
                          {meet.workpackages?.map((wp) => {
                            return (
                              <Badge bg="secondary" className="me-1">
                                {wp.title}
                              </Badge>
                            );
                          })}
                        </td>
                        <td>
                          {meet.tasks?.map((task) => {
                            return (
                              <Badge bg="secondary" className="me-1">
                                {task.title}
                              </Badge>
                            );
                          })}
                        </td>

                        <td>
                          <a
                            rel="noreferrer"
                            target="_blank"
                            href={meet.meetingLink}
                          >
                            {meet.meetingLink}
                          </a>
                        </td>
                        <td>
                          {meet.objective}
                          {meet.objective?.length > 50 ? (
                            <>
                              {expandedDescriptions[meet._id]
                                ? meet.objective
                                : `${meet.objective.slice(0, 50)}... `}
                              <span
                                onClick={() => toggleDescription(meet._id)}
                                style={{ color: "blue", cursor: "pointer" }}
                              >
                                {expandedDescriptions[meet._id]
                                  ? "Show less"
                                  : "Show more"}
                              </span>
                            </>
                          ) : (
                            meet.objective
                          )}
                        </td>

                        <td>
                          {meet.startDate &&
                            format(meet.startDate, "MM/dd/yyyy")}
                        </td>
                        <td>
                          {meet.endDate && format(meet.endDate, "MM/dd/yyyy")}
                        </td>
                        <td>{meet.time}</td>
                        <td>{meet.duration}</td>
                        <td>{meet.meetingPlatform}</td>
                        <td>{meet.meetingType}</td>
                        {role !== "staff" && (
                          <td className="actions">
                            <Button
                              title="Edit"
                              size="sm"
                              onClick={() => handleEdit(meet)}
                            >
                              <BsPencilSquare />
                            </Button>{" "}
                            <Button
                              size="sm"
                              variant="danger"
                              onClick={() => handledelete(meet._id)}
                              title="Delete"
                            >
                              <BsTrash />
                            </Button>{" "}
                          </td>
                        )}
                      </tr>
                    ))}
                  </>
                </tbody>
              </Table>

              {pagination?.totalPages > 1 && (
                <ReactPaginate
                  breakLabel="..."
                  nextLabel="Next >"
                  previousLabel="< Prev"
                  onPageChange={handlePageClick}
                  pageCount={pagination.totalPages}
                  forcePage={currentPage}
                  containerClassName="pagination"
                  activeClassName="active"
                  pageRangeDisplayed={3}
                  marginPagesDisplayed={1}
                />
              )}
            </div>
          ) : (
            <NoDataFound
              icon={<SiGooglemeet size={50} />}
              title="Meetings not found"
              description="Try to Create Meetings"
            />
          )}

          {showForm && (
            <MeetingModal
              showForm={showForm}
              setShowForm={setShowForm}
              editingMeeting={editingMeeting}
              setEditingMeeting={setEditingMeeting}
            />
          )}
        </>
      )}
    </>
  );
}

export default Meeting;
